var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEditMessageWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8865 6.83278L15.2549 3.41642L16.3208 2.29568C17.7613 1.14161 19.4727 1.32012 20.2252 2.29568C20.7133 2.92837 21.2013 4.351 20.2252 5.36863L18.8865 6.83278ZM6.55962 19.0393L1.67911 20.2891L2.85148 15.4155L13.8804 4.39252L17.7848 7.97064L6.55962 19.0393ZM15.1553 1.13654L1.70879 14.5831C1.58078 14.7111 1.48854 14.873 1.44524 15.048L0.0296216 20.7162C-0.0550898 21.0569 0.0446814 21.4183 0.293168 21.6687C0.483298 21.8588 0.739315 21.9624 1.00098 21.9624C1.08193 21.9624 1.16287 21.953 1.24382 21.9323L6.91384 20.5148C7.09079 20.4715 7.2508 20.3792 7.37881 20.2512L20.8253 6.80468C21.5821 6.04793 22 5.0408 22 3.96967C22 2.89854 21.584 1.8933 20.8253 1.13654C19.3118 -0.378848 16.6707 -0.378848 15.1553 1.13654Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditMessageWhite);
export default __webpack_public_path__ + "static/media/icEditMessageWhite.44f436e6dabef17b9d5a541772e0ae77.svg";
export { ForwardRef as ReactComponent };